// ----------------------------------------------------------------------
// <copyright file="Izenda.Routes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var Route = require('react-router').Route;
  var IndexRedirect = require('react-router').IndexRedirect;
  var Config = require('config');

  var Container = require('Izenda.Container');

  // Layouts
  var FullLayout = require('share/components/layout/Izenda.FullLayout');

  var SettingsRoutes = require('modules/Settings/Izenda.SettingsRoutes');
  var ReportViewerContainer = require('modules/Reports/ReportViewer/Izenda.ReportViewerContainer');
  var ReportRoutes = require('modules/Reports/Izenda.ReportRoutes');
  var ExploreRoutes = require('modules/Explore/Izenda.ExploreRoutes');
  var ReportDesignerRoutes = require('modules/ReportDesigner/Izenda.ReportDesignerRoutes');
  var DashboardRoutes = require('modules/Dashboard/Izenda.DashboardRoutes');
  var ContentRoutes = require('./Izenda.ContentRoutes').contentRoutes;
  var MyProfileRoutes = require('modules/MyProfile/Izenda.MyProfileRoutes');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var NotFound = require('share/components/controls/Izenda.NotFound');
  var NoPermission = require('share/components/controls/Izenda.NoPermission');
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var SecurityDetail = require('logic/models/Izenda.SecurityDetail');
  var uiState = require('logic/Izenda.UiState');

  var routes = function () {
    var BaseUrl = Config.BaseUrl || '/';
    var REPORTS_ROUTE = routeUtils.getConfigRoute('Report');
    var REPORT_VIEWER_ROUTE = routeUtils.getConfigRoute('ReportViewer');
    var REPORT_VIEWER__DETAIL_ROUTE = routeUtils.getConfigRoute('ReportViewer', 'ReportViewerDetail');
    var LOGIN_LINK = routeUtils.getRouteUrl(routeUtils.getConfigRoute('Account', 'Login'));

    function requireAuth(nextState, replace) {
      // check user browses to setting page.
      // if db is setup then we check for login process, otherwise we go to setting page for setting.
      if (nextState.params.notSetupDatabase)
        return;

      if (uiState.needLogin) {
        replace({ nextPathname: nextState.location.pathname }, LOGIN_LINK);
      }
    }

    /**
     * onEnter event
     * @params {Object} next state
     * @params {Object} replace
     */
    function onEnter(nextState, replace) {
      requireAuth(nextState, replace);
      setBodyClassByRoute(nextState.location.pathname);
    }

    /**
     * onChange event
     * @params {Object} prev state
     * @params {Object} next state
     * @params {Object} replace
     */
    function onChange(prevState, nextState, replace) {
      requireAuth(nextState, replace);
      setBodyClassByRoute(nextState.location.pathname);
    }

    /**
     * @method setBodyClassByRoute
     * @description add hide-overflow class on any page that is not Explore page
     * @param {string} currRoute route of page that user navigated to
     */
    function setBodyClassByRoute(currRoute) {
      if (currRoute === routeUtils.getRouteUrl(routeUtils.getConfigRoute('Explore'))) {
        document.getElementById('izenda-root').classList.remove('hide-overflow');
      } else {
        document.getElementById('izenda-root').classList.add('hide-overflow');
      }
    }

    return (
      <Route path={BaseUrl} component={Container}>
        <IndexRedirect to={LOGIN_LINK} />
        <Route component={FullLayout} onEnter={onEnter} onChange={onChange}>
          {ExploreRoutes()}
          {SettingsRoutes()}
          {ReportDesignerRoutes()}
          {DashboardRoutes()}
          {ReportRoutes()}
          <Route path={REPORT_VIEWER_ROUTE.path}>
            <Route path={REPORT_VIEWER__DETAIL_ROUTE.path} component={ReportViewerContainer} />
          </Route>
          {MyProfileRoutes()}
          <Route path='NoPermission' component={NoPermission}></Route>
        </Route>
        {ContentRoutes()}
      </Route>
    );
  };
  module.exports = routes;
})();



// WEBPACK FOOTER //
// ./ui/routes/Izenda.Routes.jsx